import React from 'react';
import ActivitySelector from './ActivitySelector';
import { PropTypes } from 'prop-types';
import { TorgaContext } from '../TorgaContext';
import { getActivitiesForRoutineID } from '../Routine/selectors';

export default function SortableActivityList({ routineID }) {
  const { state } = React.useContext(TorgaContext);

  const activities = getActivitiesForRoutineID(state, routineID);

  return (
    <div>
      <h1>SortableActivityList</h1>

      <ActivitySelector routineID={routineID} />

      <p>Found Activities: {activities.length}</p>
      {activities.map((activity) => (
        <div key={activity.id}>{activity.name}</div>
      ))}
    </div>
  );
}

SortableActivityList.propTypes = {
  routineID: PropTypes.number.isRequired,
};
